import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class PriorityService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/priorities', query);
  }

  create(body: any) {
    return this.post('/v2/priority', body);
  }

  find(id) {
    return this.get('/priority/' + id);
  }

  update(id, body) {
    return this.put('/priority/' + id, body);
  }

  allPriority() {
    return this.get('/all-priority');
  }

  _delete(id) {
    return this.delete('/priority/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Priority.service.ts